// src/components/common/StatCard.jsx
import React from 'react';
import { TrendingUp } from 'lucide-react';

const StatCard = ({ title, value, icon: Icon, color = 'blue', trend }) => {
  // Updated color map to remove all "dark:" classes
  const colorClasses = {
    blue: 'bg-blue-100 text-blue-600',
    green: 'bg-green-100 text-green-600',
    red: 'bg-red-100 text-red-600',
    purple: 'bg-purple-100 text-purple-600',
    orange: 'bg-orange-100 text-orange-600',
  };

  // Simplified logic for light-mode only
  const iconBgClass = colorClasses[color] ? colorClasses[color].split(' ')[0] : colorClasses.blue.split(' ')[0];
  const iconTextClass = colorClasses[color] ? colorClasses[color].split(' ')[1] : colorClasses.blue.split(' ')[1];

  return (
    // Removed "dark:bg-gray-800" and "dark:border-gray-700"
    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
      <div className="flex items-center justify-between">
        <div>
          {/* Removed "dark:text-gray-400" */}
          <p className="text-sm font-medium text-gray-600">{title}</p>
          {/* Removed "dark:text-white" */}
          <p className="text-2xl font-bold text-gray-900 mt-2">{value}</p>
          {trend && (
            <div className="flex items-center mt-2">
              <TrendingUp className="w-4 h-4 text-green-500 mr-1" />
              {/* Removed "dark:text-green-400" */}
              <span className="text-sm text-green-600">{trend}</span>
            </div>
          )}
        </div>
        <div className={`w-12 h-12 ${iconBgClass} rounded-lg flex items-center justify-center`}>
          <Icon className={`w-6 h-6 ${iconTextClass}`} />
        </div>
      </div>
    </div>
  );
};

export default StatCard;
